(function($, d, w) {
    $(window).on("load", onReady);

    function onReady() {
        const elements = $('.tg-sc-portfolio');
        if(elements.length > 0) {
            elements.each((index, element) => {
                new Portfolio(element);
            });
        }
    }

    class Portfolio {
        constructor(element) {
            this.$element = $(element);
            this.init();
        }

        init() {
            this.uid = this.$element.attr("data-uid");

            this.infoBubble = null;

            this.selectedCats = [];

            this.isSearch = false;

            this.moreLabel = this.$element.attr("data-more-label");

            this.$searchButton = this.$element.find(".tg-portfolio-filter-search-button");
            this.$searchAbort = this.$element.find(".tg-portfolio-filter-search-abort");
            this.$searchField = this.$element.find(".tg-portfolio-filter-search");
            this.$searchResults = this.$element.find(".tg-portfolio-search-results-inner");
            //this.$search.stick_in_parent({offset_top: 67, parent: this.$element});
            this.$searchButton.on("click", this.onSearchButtonClick.bind(this));
            this.$searchAbort.on("click", this.onSearchAbortClick.bind(this));
            this.$searchField.on('keyup', this.onSearchFieldKey.bind(this));

            this.createMap();
            this.createPins();

            this.filterMarkers();

            $(w).on("resize", this.onResize.bind(this));
            this.onResize();
        }
        createMap() {
            let $map = this.$element.find("> .tg-sc-portfolio-map > .tg-sc-portfolio-map-inner");

            this.map = new google.maps.Map($map.get(0), {
                gestureHandling: 'cooperative',
                zoom: 8,
                styles: [{
                    "featureType": "administrative.locality",
                    "elementType": "all",
                    "stylers": [{"hue": "#2c2e33"}, {"saturation": 7}, {"lightness": 19}, {"visibility": "on"}]
                }, {
                    "featureType": "landscape",
                    "elementType": "all",
                    "stylers": [{"hue": "#ffffff"}, {"saturation": -100}, {"lightness": 100}, {"visibility": "simplified"}]
                }, {
                    "featureType": "poi",
                    "elementType": "all",
                    "stylers": [{"hue": "#ffffff"}, {"saturation": -100}, {"lightness": 100}, {"visibility": "off"}]
                }, {
                    "featureType": "road",
                    "elementType": "geometry",
                    "stylers": [{"hue": "#bbc0c4"}, {"saturation": -93}, {"lightness": 31}, {"visibility": "simplified"}]
                }, {
                    "featureType": "road",
                    "elementType": "labels",
                    "stylers": [{"hue": "#bbc0c4"}, {"saturation": -93}, {"lightness": 31}, {"visibility": "on"}]
                }, {
                    "featureType": "road.arterial",
                    "elementType": "labels",
                    "stylers": [{"hue": "#bbc0c4"}, {"saturation": -93}, {"lightness": -2}, {"visibility": "simplified"}]
                }, {
                    "featureType": "road.local",
                    "elementType": "geometry",
                    "stylers": [{"hue": "#e9ebed"}, {"saturation": -90}, {"lightness": -8}, {"visibility": "simplified"}]
                }, {
                    "featureType": "transit",
                    "elementType": "all",
                    "stylers": [{"hue": "#e9ebed"}, {"saturation": 10}, {"lightness": 69}, {"visibility": "on"}]
                }, {
                    "featureType": "water",
                    "elementType": "all",
                    "stylers": [{"hue": "#e9ebed"}, {"saturation": -78}, {"lightness": 67}, {"visibility": "simplified"}]
                }]
            });
        }

        createPins() {
            this.pinItems = [];
            this.$element.find('.tg-sc-portfolio-items').each(function(index, element) {
                let pin = new PortfolioPin(element, this);
                this.pinItems["cat_" + pin.cat] = pin;
            }.bind(this));
        }

        getClusterOptions() {
            let clusterIcon1 = this.$element.attr("data-cluster-1");
            let clusterIcon2 = this.$element.attr("data-cluster-2");
            let clusterIcon3 = this.$element.attr("data-cluster-3");

            let clusterStyles = [
                {
                    textColor: 'white',
                    url: clusterIcon1,
                    height: 50,
                    width: 50
                },
                {
                    textColor: 'white',
                    url: clusterIcon2,
                    height: 50,
                    width: 50
                },
                {
                    textColor: 'white',
                    url: clusterIcon3,
                    height: 50,
                    width: 50
                }
            ];

            let clusterOptions = {
                gridSize: 50,
                styles: clusterStyles,
                maxZoom: 14,
                ignoreHidden: true,
                averageCenter: true
            };

           return clusterOptions;
        }

        onResize() {
            this.map.fitBounds(this.bounds);
        }

        setCat(cat) {
            this.selectedCats.push(cat);
            this.filterMarkers();
        }

        unsetCat(cat) {
            let index = this.selectedCats.indexOf(cat);
            if (index !== -1) {
                this.selectedCats.splice(index, 1);
            }
            this.filterMarkers();
        }

        filterMarkers() {
            this.closeInfoBubble();

            this.bounds = new google.maps.LatLngBounds();
            let visibleMarkers = [];

            if(!this.isSearch) {
                if (this.selectedCats.length <= 0) {
                    for (var key in this.pinItems) {
                        let pins = this.pinItems[key];
                        for (var key2 in pins.markers) {
                            let marker = pins.markers[key2].marker;
                            visibleMarkers.push(marker);
                            marker.setVisible(true);
                            this.bounds.extend(marker.position);
                        }
                    }
                } else {
                    for (var key in this.pinItems) {
                        let pins = this.pinItems[key];
                        let index = this.selectedCats.indexOf(pins.cat);
                        if (index === -1) {
                            for (var key2 in pins.markers) {
                                let marker = pins.markers[key2].marker;
                                marker.setVisible(false);
                            }
                        } else {
                            for (var key2 in pins.markers) {
                                let marker = pins.markers[key2].marker;
                                visibleMarkers.push(marker);
                                marker.setVisible(true);
                                this.bounds.extend(marker.position);
                            }
                        }
                    }
                }
            } else {
                var searchedPins = this.$searchResults.find(".tg-sc-portfolio-item");
                var searchedIds = [];
                searchedPins.each(function(index, element) {
                   let $ele = $(element);
                    searchedIds.push(parseInt($ele.attr("data-id")));
                });
                for (var key in this.pinItems) {
                    let pins = this.pinItems[key];
                    for (var key2 in pins.markers) {
                        let marker = pins.markers[key2].marker;
                        let markerId = marker.tgpin.id;
                        if(searchedIds.indexOf(markerId) > -1) {
                            marker.setVisible(true);
                            this.bounds.extend(marker.position);
                        } else {
                            marker.setVisible(false);
                        }
                    }
                }
            }

            this.map.fitBounds(this.bounds);
            this.clusterer = new MarkerClusterer(this.map, visibleMarkers, this.getClusterOptions());
        }

        onSearchFieldKey(e) {
            if(e.keyCode == 13) {
                this.searchItems();
            }
        }

        onSearchButtonClick(e) {
            this.searchItems();
        }

        onSearchAbortClick(e) {
            this.searchAbort();
        }

        searchItems() {
            if(!this.loading) {
                let value = this.$searchField.val();
                if(value.trim() != "") {
                    let root = this;
                    root.$element.addClass("tg-sc-portfolio-loading").removeClass("tg-sc-portfolio-search-not-found");
                    root.loading = true;
                    root.isSearch = true;

                    $.ajax({
                        url: tg_portfolio.tg_ajax,
                        data: {
                            action: "tg_portfolio_get_items_by_search",
                            search: value,
                            more_label: root.moreLabel,
                        },
                        success: function (response) {
                            root.$searchResults.empty();
                            root.$element.addClass("tg-sc-portfolio-search-active");
                            root.$searchResults.append(response);
                            if(response.trim() == "") {
                                root.$element.addClass("tg-sc-portfolio-search-not-found");
                            }
                            root.$element.removeClass("tg-sc-portfolio-loading");
                            root.loading = false;
                            root.filterMarkers();
                        }
                    });
                } else {
                    this.searchAbort();
                }
            }
        }

        searchAbort() {
            this.isSearch = false;
            this.loading = false;
            for (var key in this.pinItems) {
                this.pinItems[key].unloadItems();
            }
            this.$searchResults.empty();
            this.$searchField.val("");
            this.$element.removeClass("tg-sc-portfolio-search-active").removeClass("tg-sc-portfolio-search-not-found");
            this.filterMarkers();
        }

        closeInfoBubble() {
            if(this.infoBubble != null) {
                this.infoBubble.close();
            }
        }

        addInfoBubble(marker) {
            this.closeInfoBubble();

            let map = this.map;
            let lat = marker.lat;
            let lng = marker.lng;
            let area = marker.area;
            let headline = marker.headline;
            let catTitle = marker.catTitle;
            let urlOut = "";
            let url = marker.url;
            if(url != "") {
                urlOut = '<div class="tg-portfolio-map-infobox-link"><a href="' + url + '" class="tg-portfolio-map-infobox-link-button">' + this.moreLabel + ' <i class="fa fa-arrow-right"></i></a></div>';
            }

            let root = this;

            this.infoBubble = new InfoBubble({
                maxWidth: 300,
                content: '<div class="tg-portfolio-map-infobox-title">' + headline + '</div><div class="tg-portfolio-map-infobox-cat">' + catTitle + '</div><div class="tg-portfolio-map-infobox-area">' + area + '</div>' + urlOut,
                position: new google.maps.LatLng(lat, lng),
                borderRadius: 0,
                backgroundColor: '#DCDCDC',
                borderWidth: 0,
                disableAnimation: true,
                disableAutoPan: true,
                hideCloseButton: false,
                arrowSize: 10,
                closeSrc: window["tg_portfolio_" + root.uid + "_url"] + "/assets/dist/icons/info-bubble-close.png",
                backgroundClassName: 'tg-portfolio-map-infobox-content',
            });
            this.infoBubble.open(this.map, marker.marker);
        }
    }

    class PortfolioPin {
        constructor(element, holder) {
            this.$element = $(element);
            this.holder = holder;
            this.init();
        }

        init() {
            this.cat = parseInt(this.$element.attr("data-cat"));
            this.open = this.$element.hasClass("tg-sc-portfolio-open");
            if(this.open) {
                this.holder.setCat(this.cat);
            }
            this.loading = false;
            this.pinColor = this.$element.attr("data-color");
            this.pinIcon = this.$element.attr("data-icon");
            this.pinWidth = parseFloat(this.$element.attr("data-icon-width"));
            this.pinHeight = parseFloat(this.$element.attr("data-icon-height"));
            this.pin = new google.maps.MarkerImage(
                this.pinIcon,
                null,
                null,
                null,
                new google.maps.Size(this.pinWidth, this.pinHeight)
            );

            this.$itemButton = this.$element.find('.tg-sc-portfolio-list-button');
            this.$itemButton.on("click", this.onToggle.bind(this));

            this.setMarkers();
        }

        setMarkers() {
            this.markers = [];
            let mapItems = window["tg_portfolio_" + this.holder.uid + "_items_" + this.cat];
            let i = 0;
            while(i < mapItems.length) {
                let item = mapItems[i];
                let cat = parseInt(item.cat);
                let catTitle = item.catTitle;
                let icon = this.pin;
                let lat = parseFloat(item.lat);
                let lng = parseFloat(item.lng);
                let headline = item.headline;
                let subline = item.subline;
                let url = item.url;
                let id = item.id;
                let area = item.area;
                let marker = new PortfolioMarker(this, icon, id, lat, lng, headline, subline, area, url, catTitle);
                this.markers["marker_" + id] = marker;
                i = i + 1;
            }
        }

        onToggle() {
            if(!this.loading) {
                if (this.open) {
                    this.unloadItems();
                } else {
                    this.loadItems();
                }
            }
        }

        unloadItems() {
            this.$element.find('.tg-sc-portfolio-item').remove();
            this.holder.unsetCat(this.cat);
            this.$element.removeClass("tg-sc-portfolio-open");
            this.open = false;
            this.$itemButton.trigger("sticky_kit:detach");
        }

        loadItems() {
            this.$element.addClass("tg-sc-portfolio-open");
            this.open = true;
            this.$itemButton.stick_in_parent({offset_top: 67});
            let root = this;
            this.$element.addClass("tg-sc-portfolio-loading");
            this.loading = true;
            $.ajax({
                url: tg_portfolio.tg_ajax,
                data: {
                    action: "tg_portfolio_get_items_by_cat",
                    cat: root.cat,
                    more_label: root.holder.moreLabel,
                },
                success: function (response) {
                    root.$element.find('.tg-sc-portfolio-list').append(response);
                    root.$element.removeClass("tg-sc-portfolio-loading");
                    root.holder.setCat(root.cat);
                    root.loading = false;
                }
            });
        }
    }

    class PortfolioMarker {
        constructor(holder, icon, id, lat, lng, headline, subline, area, url, catTitle) {
            this.holder = holder;
            this.headline = headline;
            this.subline = subline;
            this.url = url;
            this.lat = lat;
            this.lng = lng;
            this.icon = icon;
            this.catTitle = catTitle;
            this.id = id;
            this.icon = icon;
            this.area = area;
            this.init();
        }

        init() {
            let latLng = new google.maps.LatLng(this.lat, this.lng);
            let marker = new google.maps.Marker({
                position: latLng,
                map: this.holder.holder.map,
                clickable: true,
                optimized: false,
                icon: this.icon,
            });
            marker.addListener('click', this.onClick.bind(this));
            marker.tgpin = this;
            this.marker = marker;
        }

        onClick() {
            this.holder.holder.addInfoBubble(this);
        }
    }

})(jQuery, document, window);
